var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.5647 24 24 18.5529 24 12C24 5.43529 18.5529 0 11.9882 0C5.43529 0 0 5.43529 0 12C0 18.5529 5.44706 24 12 24ZM10.6706 17.7529C10.2706 17.7529 9.94118 17.5882 9.63529 17.1765L6.68235 13.5529C6.50588 13.3176 6.4 13.0588 6.4 12.7882C6.4 12.2588 6.81177 11.8235 7.34118 11.8235C7.68235 11.8235 7.94118 11.9294 8.23529 12.3176L10.6235 15.4L15.6471 7.32941C15.8706 6.97647 16.1765 6.78824 16.4824 6.78824C17 6.78824 17.4824 7.14118 17.4824 7.69412C17.4824 7.95294 17.3294 8.22353 17.1882 8.47059L11.6588 17.1765C11.4118 17.5647 11.0706 17.7529 10.6706 17.7529Z",
    fill: "#7B5DF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.46bf5cb11604798904698f669e96fdc3.svg";
export { ForwardRef as ReactComponent };